interface ScoreBarProps {
  value: number | null | undefined
  max?: number
  showLabel?: boolean
  className?: string
}

function colorFor(score: number, max: number): string {
  const pct = (score / max) * 100
  if (pct >= 75) return 'bg-emerald-500'
  if (pct >= 50) return 'bg-amber-500'
  if (pct >= 25) return 'bg-orange-500'
  return 'bg-red-500'
}

export function ScoreBar({
  value,
  max = 10,
  showLabel = true,
  className = '',
}: ScoreBarProps) {
  if (value === null || value === undefined) {
    return (
      <div className={`flex items-center gap-2 ${className}`}>
        <div className="h-1.5 w-24 rounded-full bg-slate-800" />
        {showLabel && <span className="text-xs text-slate-500">--</span>}
      </div>
    )
  }
  const pct = Math.min(100, Math.max(0, (value / max) * 100))
  const color = colorFor(value, max)
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <div className="h-1.5 w-24 overflow-hidden rounded-full bg-slate-800">
        <div className={`h-full ${color} transition-all`} style={{ width: `${pct}%` }} />
      </div>
      {showLabel && (
        <span className="font-mono text-xs text-slate-300">{value.toFixed(1)}</span>
      )}
    </div>
  )
}

interface PassRateBarProps {
  rate: number // 0..1
  label?: string
}

export function PassRateBar({ rate, label }: PassRateBarProps) {
  const pct = Math.min(100, Math.max(0, rate * 100))
  const color = pct >= 70 ? 'bg-emerald-500' : pct >= 40 ? 'bg-amber-500' : 'bg-red-500'
  return (
    <div className="flex items-center gap-2">
      <div className="h-1.5 w-20 overflow-hidden rounded-full bg-slate-800">
        <div className={`h-full ${color}`} style={{ width: `${pct}%` }} />
      </div>
      <span className="font-mono text-xs text-slate-300">{pct.toFixed(0)}%</span>
      {label && <span className="text-xs text-slate-500">{label}</span>}
    </div>
  )
}
